import request from '../../axios';
import {ILoanRequestRuleResponse} from './types';

export const getLoanRequestRule = async (loanRequestGuid?: string) => {
  const {data}: {data: ILoanRequestRuleResponse} = await request.get(
    `/api/v2/payment/loan-type-rule/loan-request/` + loanRequestGuid,
  );

  return data;
};
